import { createTheme } from "@mui/material";
import createPalette from "@mui/material/styles/createPalette";
import createTypography from "@mui/material/styles/createTypography";

const palette = createPalette({
  primary: {
    main: "#F2F2F2",
    dark: "#828282",
    contrastText: "#565656",
    light: "#a8a8a8",
  },
  secondary: {
    main: "#2E2E2E",
    dark: "rgba(46, 46, 46, 0.6)",
    light: "#CACACA",
    contrastText: "#D9D9D9",
  },
  error: {
    main: "#F34141",
  },
  success: {
    main: "rgba(83, 180, 131, 1)",
    //main: "#2A5A42"
  },
  warning: {
    main: "rgba(255, 209, 106, 1)",
  },
  text: {
    primary: "#2E2E2E",
    placeholder: "#828282",
    secondary: "#F2F2F2",
    disabled: "#CACACA",
    black: "#000",
  },
  background: {
    primary: "#F2F2F2",
    paper: "#D9D9D9",
    accent: "#E4E4E4",
    active: "rgba(83, 180, 131, 1)",
    inactive: "#D7D7D7",
  },
});

const typography = createTypography(palette, {
  fontFamily: "Ttnorms, sans-serif",
  fontWeightMedium: 500,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightBold: 700,
  fontSize: 14,
  h1: {
    fontSize: "1.5rem",
    lineHeight: 1.4,
  },
  h2: {
    fontSize: "0.875rem",
    lineHeight: 1.4,
  },
  h3: {
    fontSize: "0.875rem",
    lineHeight: 1.4,
  },
  h4: {
    fontSize: "0.875rem",
    lineHeight: 1.4,
  },
  h5: {
    fontSize: "0.875rem",
    lineHeight: 1.4,
  },
  body1: {
    fontSize: "0.875rem",
    lineHeight: 1.4,
  },
  body2: {
    fontSize: "0.75rem",
    lineHeight: 1.6,
  },
});

const themeConfig = createTheme({
  palette,
  typography,
  layout: {
    contentMaxWidth: 600,
  },
  shape: {
    borderRadius: 44,
  },

  components: {
    MuiButton: {
      defaultProps: {
        variant: "contained",
        size: "small",
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          borderRadius: 0,
          marginTop: "4px",
        },
      },
    },
    // @ts-expect-error
    MuiLoadingButton: {
      defaultProps: {
        loadingPosition: "end",
        variant: "contained",
        size: "small",
      },
    },
  },
});

export default themeConfig;
